// مپینگ نامزدها برای استفاده در سراسر اپلیکیشن
export const CANDIDATES_MAP = {
  // مهندسی کامپیوتر
  1: { name: 'علی محمد شاه‌حسینی', gender: 'male', major: 'مهندسی کامپیوتر', photo: 'https://i.postimg.cc/HnRwp5jb/IMG-20251119-223955-992.jpg' },
  2: { name: 'عرفان تبار‌ملاحسن', gender: 'male', major: 'مهندسی کامپیوتر', photo: 'https://i.postimg.cc/g0YQCr7X/IMG-20251117-140951-442.jpg' },
  3: { name: 'نگار توسلی', gender: 'female', major: 'مهندسی کامپیوتر', photo: 'https://i.postimg.cc/pTQfxpDM/IMG-20251114-215112-735.jpg' },
  4: { name: 'زهرا محمدی', gender: 'female', major: 'مهندسی کامپیوتر', photo: null },
  5: { name: 'هادی مستوفی‌زاده', gender: 'male', major: 'مهندسی کامپیوتر', photo: 'https://i.postimg.cc/d1R2vLGB/IMG-20251114-215051-745.jpg' },
  6: { name: 'نیوشا اللّه‌دادی', gender: 'female', major: 'مهندسی کامپیوتر', photo: 'https://i.postimg.cc/4xbZF73j/4960986466301446957.jpg' },
  7: { name: 'ابوالفضل علیزاده', gender: 'male', major: 'مهندسی کامپیوتر', photo: 'https://i.postimg.cc/ZRP8ZC6x/IMG-20251114-184832-710.jpg' },
  8: { name: 'علی اصغر اقبال', gender: 'male', major: 'مهندسی کامپیوتر', photo: 'https://i.postimg.cc/Jn3NmGj3/IMG-20251114-215051-903.jpg' },
  9: { name: 'ابوالفضل اصغری', gender: 'male', major: 'مهندسی کامپیوتر', photo: 'https://i.postimg.cc/Hx0wHVb3/IMG-20251114-215052-393.jpg' },

  // مهندسی شیمی
  10: { name: 'ابوالفضل قربانی', gender: 'male', major: 'مهندسی شیمی', photo: 'https://i.postimg.cc/MTRgWrf6/IMG-5158.jpg' },
  11: { name: 'امیر یزدان‌ پناه', gender: 'male', major: 'مهندسی شیمی', photo: null },
  12: { name: 'مهدی علیزاده', gender: 'male', major: 'مهندسی شیمی', photo: 'https://i.postimg.cc/zvJnf8k6/IMG-20251114-215101-412.jpg' },
  13: { name: 'شقایق صادقی', gender: 'female', major: 'مهندسی شیمی', photo: null },
  14: { name: 'فاطمه نعیمی', gender: 'female', major: 'مهندسی شیمی', photo: 'https://i.postimg.cc/xdwQFv2j/5821451858038426580.jpg' },
  15: { name: 'محمدفاضل ولی پور', gender: 'male', major: 'مهندسی شیمی', photo: 'https://i.postimg.cc/0jF2xTgV/5823327354292472698.jpg' },
  16: { name: 'پارمیدا حبیبی شور کچالی', gender: 'female', major: 'مهندسی شیمی', photo: 'https://i.postimg.cc/KcLPVxng/5823272288516770569.jpg' },
  17: { name: 'ماهک عنایتی', gender: 'female', major: 'مهندسی شیمی', photo: null },
  18: { name: 'عرشیا وحیدی', gender: 'male', major: 'مهندسی شیمی', photo: 'https://i.postimg.cc/rwq7sh8G/4960986466301446955.jpg' },
  19: { name: 'کیانا نجف نژاد', gender: 'female', major: 'مهندسی شیمی', photo: 'https://i.postimg.cc/0j8pNPfx/IMG-20251114-215111-717.jpg' },

  // مهندسی معماری
  20: { name: 'رضا بیاتی', gender: 'male', major: 'مهندسی معماری', photo: null },
  21: { name: 'سیده فاطمه حسینی', gender: 'female', major: 'مهندسی معماری', photo: 'https://i.postimg.cc/SKJrxkLx/IMG000-(1).jpg' },
  22: { name: 'آرزو رسولی', gender: 'female', major: 'مهندسی معماری', photo: null },
  23: { name: 'نادیا شرامه', gender: 'female', major: 'مهندسی معماری', photo: null },
  24: { name: 'یلدا زندی زیارانی', gender: 'female', major: 'مهندسی معماری', photo: null },
  105: { name: 'مهدی رمضانی', gender: 'male', major: 'مهندسی معماری', photo: null },
  106: { name: 'مریم رزقی', gender: 'female', major: 'مهندسی معماری', photo: null },
  107: { name: 'پرستو ولی', gender: 'female', major: 'مهندسی معماری', photo: null },
  108: { name: 'هلیا پارسایان', gender: 'female', major: 'مهندسی معماری', photo: null },
  109: { name: 'معصومه معینی', gender: 'female', major: 'مهندسی معماری', photo: null },
  110: { name: 'رومینا حسین‌زاده', gender: 'female', major: 'مهندسی معماری', photo: null },
  111: { name: 'معصومه ازوی', gender: 'female', major: 'مهندسی معماری', photo: null },

  // مهندسی مکانیک
  25: { name: 'محمد رسول قربانی', gender: 'male', major: 'مهندسی مکانیک', photo: null },
  26: { name: 'مهدی ایمانی', gender: 'male', major: 'مهندسی مکانیک', photo: 'https://i.postimg.cc/QNbtVzD2/5819017388970675257.jpg' },
  27: { name: 'حامد یزدانی', gender: 'male', major: 'مهندسی مکانیک', photo: 'https://i.postimg.cc/tTFsrRLJ/5819211972464020467.jpg' },
  28: { name: 'میثم ابراهیم پور ملکشاه', gender: 'male', major: 'مهندسی مکانیک', photo: null },
  29: { name: 'محمد رنجبر', gender: 'male', major: 'مهندسی مکانیک', photo: 'https://i.postimg.cc/Wz2M4TnD/IMG-20251114-215110-259.jpg' },

  // مهندسی عمران
  30: { name: 'امیررضا اکبری', gender: 'male', major: 'مهندسی عمران', photo: null },
  31: { name: 'هدیه شکیبایی مرام', gender: 'female', major: 'مهندسی عمران', photo: null },
  32: { name: 'مهدی اجواری', gender: 'male', major: 'مهندسی عمران', photo: 'https://i.postimg.cc/1XJDn2C0/IMG-20251114-215118-844.jpg' },
  33: { name: 'امیرمحمد جوکار', gender: 'male', major: 'مهندسی عمران', photo: 'https://i.postimg.cc/2y2nbMcL/IMG-20251114-215117-471.jpg' },
  34: { name: 'مهدیسا آقاگلی', gender: 'female', major: 'مهندسی عمران', photo: null },
  35: { name: 'علی فرهادی', gender: 'male', major: 'مهندسی عمران', photo: null },
  37: { name: 'سید محمد یاسین حسنی', gender: 'male', major: 'مهندسی عمران', photo: null },
  38: { name: 'سهیل تقوی', gender: 'male', major: 'مهندسی عمران', photo: null },
  39: { name: 'امیرحسین رضایی', gender: 'male', major: 'مهندسی عمران', photo: null },
  40: { name: 'فریبرز علایی', gender: 'male', major: 'مهندسی عمران', photo: null },

  // مهندسی صنایع
  41: { name: 'مریم شهروزی', gender: 'female', major: 'مهندسی صنایع', photo: null },
  42: { name: 'پارسا شایان فر', gender: 'male', major: 'مهندسی صنایع', photo: null },
  43: { name: 'ابوالفضل احمدی', gender: 'male', major: 'مهندسی صنایع', photo: null },
  44: { name: 'مریم رضازاده', gender: 'female', major: 'مهندسی صنایع', photo: null },
  45: { name: 'امیرحسین غلامی بایی', gender: 'male', major: 'مهندسی صنایع', photo: null },
  46: { name: 'نوید رضا قلی زاده', gender: 'male', major: 'مهندسی صنایع', photo: null },

  // برق-پزشکی
  47: { name: 'امیررضا اکبرزاده', gender: 'male', major: 'برق-پزشکی', photo: 'https://i.postimg.cc/RhCRtCSv/IMG-20251122-184946-734.jpg' },
  48: { name: 'محمدجواد پناه', gender: 'male', major: 'برق-پزشکی', photo: 'https://i.postimg.cc/yY7BKvgQ/IMG-20251123-112749-618.jpg' },
  49: { name: 'پرستو بابایی', gender: 'female', major: 'برق-پزشکی', photo: 'https://i.postimg.cc/mkbQrBws/IMG-20251114-215107-446.jpg' },
  50: { name: 'کوثر نجفی مرزان', gender: 'female', major: 'برق-پزشکی', photo: 'https://i.postimg.cc/L5NjYwCD/IMG-20251114-215121-705.jpg' },
  51: { name: 'فاطمه زهرا ثقفی', gender: 'female', major: 'برق-پزشکی', photo: null },
  112: { name: 'محمد قاسمی', gender: 'male', major: 'برق-پزشکی', photo: null },
  113: { name: 'روناز مینا خانی', gender: 'female', major: 'برق-پزشکی', photo: null },
  114: { name: 'فاطمه رمضانی', gender: 'female', major: 'برق-پزشکی', photo: null },
  115: { name: 'فاطمه زهرا موسوی کنتی', gender: 'female', major: 'برق-پزشکی', photo: null },
  116: { name: 'امیر حسین رحمانی', gender: 'male', major: 'برق-پزشکی', photo: null },
  117: { name: 'امیر رضا شهابی', gender: 'male', major: 'برق-پزشکی', photo: null },
  118: { name: 'مهدی ابو طالبی', gender: 'male', major: 'برق-پزشکی', photo: 'https://i.postimg.cc/4yZjcw6x/5825440542626614132.jpg' },
  119: { name: 'امیر علی پور اسحاق', gender: 'male', major: 'برق-پزشکی', photo: 'https://i.postimg.cc/d3vgCn2w/5823281896358612216.jpg' },

  // مهندسی نقشه‌برداری
  52: { name: 'امیرحسین اسدی', gender: 'male', major: 'مهندسی نقشه‌برداری', photo: null },
  53: { name: 'حسین قنبری گنگرکلا', gender: 'male', major: 'مهندسی نقشه‌برداری', photo: null },
  54: { name: 'سام موسوی', gender: 'male', major: 'مهندسی نقشه‌برداری', photo: null },
  55: { name: 'فاطمه زهرا پرتوی', gender: 'female', major: 'مهندسی نقشه‌برداری', photo: null },
  56: { name: 'رضوان فلاحی مقدم', gender: 'male', major: 'مهندسی نقشه‌برداری', photo: null },
  57: { name: 'طهورا حجازی مرزنگو', gender: 'female', major: 'مهندسی نقشه‌برداری', photo: null },
  58: { name: 'رایکا کاویان پور', gender: 'female', major: 'مهندسی نقشه‌برداری', photo: null },

  // مدیریت
  60: { name: 'امیرحسین یزدانی', gender: 'male', major: 'مدیریت', photo: null },
  61: { name: 'علی حسین‌زاده', gender: 'male', major: 'مدیریت', photo: null },
  62: { name: 'سید محمد حسینی', gender: 'male', major: 'مدیریت', photo: null },
  63: { name: 'سمانه حاجی‌پور', gender: 'female', major: 'مدیریت', photo: null },
  64: { name: 'ملیسا اصغری', gender: 'female', major: 'مدیریت', photo: null },
  65: { name: 'بیتا اصغری', gender: 'female', major: 'مدیریت', photo: null },
  66: { name: 'دنیا فتح‌الله‌پور', gender: 'female', major: 'مدیریت', photo: null },
  120: { name: 'سیده ماهان طباطبایی', gender: 'female', major: 'مدیریت', photo: null },

  // روانشناسی
  71: { name: 'آنیتا خاکپور', gender: 'female', major: 'روانشناسی', photo: null },
  72: { name: 'ماهتیسا قنبری', gender: 'female', major: 'روانشناسی', photo: null },
  73: { name: 'پویا موخر', gender: 'male', major: 'روانشناسی', photo: null },
  74: { name: 'سپیده عسگری', gender: 'female', major: 'روانشناسی', photo: null },
  75: { name: 'فاطمه سعادتی', gender: 'female', major: 'روانشناسی', photo: null },
  76: { name: 'نسیم عابدی', gender: 'female', major: 'روانشناسی', photo: null },
  77: { name: 'فاطمه طهماسب', gender: 'female', major: 'روانشناسی', photo: null },
  121: { name: 'ساجده عباسی', gender: 'female', major: 'روانشناسی', photo: null },

  // حسابداری
  78: { name: 'سید مهدی حسینی ایمنی', gender: 'male', major: 'حسابداری', photo: null },
  79: { name: 'محمد حسین یزدی', gender: 'male', major: 'حسابداری', photo: null },
  80: { name: 'محمد امین کریمی', gender: 'male', major: 'حسابداری', photo: null },
  81: { name: 'مهدی موسوی چاشمی', gender: 'male', major: 'حسابداری', photo: null },
  82: { name: 'شراگیم للهی حاجی دلایی', gender: 'male', major: 'حسابداری', photo: null },
  122: { name: 'زهرا ابراهیمی', gender: 'female', major: 'حسابداری', photo: null },
  123: { name: 'محمد حسین مختاری', gender: 'male', major: 'حسابداری', photo: null },

  // حقوق
  87: { name: 'سحر احمدزاده', gender: 'female', major: 'حقوق', photo: null },
  88: { name: 'رضا توسلی', gender: 'male', major: 'حقوق', photo: 'https://i.postimg.cc/tJXhgp5V/IMG-20251114-215108-762.jpg' },
  89: { name: 'حنانه دلفان آذری', gender: 'female', major: 'حقوق', photo: 'https://i.postimg.cc/2y2nbMc9/IMG-20251114-215133-970.jpg' },
  90: { name: 'فاطمه خضرایی', gender: 'female', major: 'حقوق', photo: null },
  91: { name: 'ستایش وحیدی', gender: 'female', major: 'حقوق', photo: null },
  92: { name: 'مهنا زمینی', gender: 'female', major: 'حقوق', photo: null },
  93: { name: 'آرمان علی‌بابایی', gender: 'male', major: 'حقوق', photo: null },
  94: { name: 'حسن توکلی', gender: 'male', major: 'حقوق', photo: null },
  95: { name: 'ابوالفضل قلی‌نژاد عمران', gender: 'male', major: 'حقوق', photo: 'https://i.postimg.cc/Fz9jKNZk/IMG-20251114-215113-308.jpg' },
  96: { name: 'سپهر جعفری', gender: 'male', major: 'حقوق', photo: 'https://i.postimg.cc/nrHvLpkV/IMG-20251114-215103-644.jpg' },
  124: { name: 'محمد شکری زاده', gender: 'male', major: 'حقوق', photo: 'https://i.postimg.cc/C1fKhbTC/IMG-3532.avif' },
  125: { name: 'محمد طاها عباسی', gender: 'male', major: 'حقوق', photo: 'https://i.postimg.cc/VvQkd5m3/5805312139739204744.jpg' },

  // تربیت بدنی و علوم ورزشی
  97: { name: 'سارینا صانعی ماتک', gender: 'female', major: 'تربیت بدنی و علوم ورزشی', photo: 'https://i.postimg.cc/prqKh4Gr/IMG-20251114-215102-768.jpg' },
  98: { name: 'سیده فاطمه تقوی', gender: 'female', major: 'تربیت بدنی و علوم ورزشی', photo: null },
  99: { name: 'زهرا رضایی', gender: 'female', major: 'تربیت بدنی و علوم ورزشی', photo: 'https://i.postimg.cc/rFg216Y8/5821060968769850376.jpg' },
  100: { name: 'نرجس غلامی', gender: 'female', major: 'تربیت بدنی و علوم ورزشی', photo: null },
  101: { name: 'عرفان بهنام', gender: 'male', major: 'تربیت بدنی و علوم ورزشی', photo: 'https://i.postimg.cc/pyMbsRML/5825815072364760288.jpg' },
  102: { name: 'سجاد زارع', gender: 'male', major: 'تربیت بدنی و علوم ورزشی', photo: null },
  103: { name: 'ماهان تقی پور', gender: 'male', major: 'تربیت بدنی و علوم ورزشی', photo: 'https://i.postimg.cc/hvpVz6yp/IMG-20251114-215119-732.jpg' },
  104: { name: 'سید حسین حسینی', gender: 'male', major: 'تربیت بدنی و علوم ورزشی', photo: 'https://i.postimg.cc/nrVkmVFt/IMG-20251122-185157-052.jpg' },
};

// تابع کمکی برای گرفتن نام نامزد
export const getCandidateName = (candidateId) => {
  const candidate = CANDIDATES_MAP[candidateId];
  return candidate ? candidate.name : `نامزد شماره ${candidateId}`;
};

// تابع کمکی برای گرفتن اطلاعات کامل نامزد
export const getCandidateInfo = (candidateId) => {
  return CANDIDATES_MAP[candidateId] || { 
    name: `نامزد شماره ${candidateId}`, 
    gender: 'male', 
    major: 'نامشخص',
    photo: null
  };
};
